import { render, staticRenderFns } from "./BorcluSgkHacizPicker.vue?vue&type=template&id=2fc285d1"
import script from "./BorcluSgkHacizPicker.vue?vue&type=script&lang=ts"
export * from "./BorcluSgkHacizPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports